// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"6f174426","223":"ac968d7f","378":"9dcc531e","512":"3a84fff3","589":"646efab5","766":"f84117af","778":"9ac2a223","823":"7b7f3ebe","879":"e6f07f4c","979":"4acf76bd"}[chunkId] + ".chunk.js";
};